import React, {useState} from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import notifier from '../../../_utils/notifier';
import { SHOP_TYPES, ARRANGEMENT_TYPE_SLUG } from '../../../config';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { createOffer } from '../../actions/shop';
import OffersFormInfo from './OffersFormInfo.jsx';
import ArrangementsForm from './Forms/ArrangementsForm.jsx';
import LessonsForm from './Forms/LessonsForm.jsx';


const OffersCreateForm = (props) => {
  const type = props.match.params.type;
  let [redirect, setRedirect] = useState(false);

  const handleFormSubmit = (formData) => {
    props.createOffer(type, formData)
      .then(response => {
        if (response) {
          notifier.success(SHOP_TYPES[type]['createMessage']);
          setRedirect(true);
        } else {
          notifier.alert(gettext('Пожалуйста, исправьте найденые ошибки.'));
        }
      });
  };

  const renderRedirect = () => {
    if (redirect) {
      return <Redirect to={ `/${props.lang}/my/content/${type}/` } />
    }
  }

  const getForm = () => {
    if (type === ARRANGEMENT_TYPE_SLUG) return <ArrangementsForm onSubmit={ handleFormSubmit }/>
    else return <LessonsForm onSubmit={ handleFormSubmit }/>
  }

  return <div>
    { renderRedirect() }
    <OffersFormInfo type={ type }/>
    { getForm() }
  </div>
};

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
  }
};
export default compose(
  connect(mapStateToProps, { createOffer }),
  LoginRequired,
  Page
)(OffersCreateForm);
